export const createPendoTracker = (apiKey, userId, accountId, isFoundry = false) => ({
  name: 'pendo',
  init: () => {
    (function (p, e, n, d, o) {
      let v, w, x, y, z;
      o = p[d] = p[d] || {};
      o._q = o._q || [];
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
      for (w = 0, x = v.length; w < x; ++w)
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
            };
        })(v[w]);
      y = e.createElement(n);
      y.async = !0;
      y.src = `https://content.pendo.${isFoundry ? 'fifoundry' : 'everfi'}.net/agent/static/${apiKey}/pendo.js`;
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');

    window.pendo.initialize({
      visitor: { id: userId },
      account: { id: accountId },
    });
  },
  track: ({ name, props }) => {
    if (window.pendo?.track) {
      window.pendo.track(name, props);
    }
  },
  teardown: () => {
    const script = document.querySelector(`script[src*="pendo.${isFoundry ? 'fifoundry' : 'everfi'}.net"]`);
    if (script?.parentNode) {
      script.parentNode.removeChild(script);
    }
    if (window.pendo) {
      delete window.pendo;
    }
  },
});
